import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { Omit } from '@40seas/entities/common';
import { AddressMatch } from '@40seas/entities/match';

export class CreateAddressMatchDto extends Omit(AddressMatch, TenantlessBaseEntityFieldsArray) {}
